// src/Room/roomSlice.ts (eller där din slice bor)
import { IRootState } from "../app/store";
import { createAppSlice } from "../app/createAppSlice";

export interface IRoomSliceState {
  test: string[];

  /** Valgt disiplin/responsibility for visning av specifiedArticles (fri streng) */
  selectedSpecifiedArticlesResponsibility: string; // "" = alle / ingen valgt
}

const initialState: IRoomSliceState = {
  test: [],
  selectedSpecifiedArticlesResponsibility: "",
};

export const roomSlice = createAppSlice({
  name: "room",
  initialState,
  reducers: (create) => ({
    setSelectedSpecifiedArticlesResponsibilityInRedux: create.reducer<string>((state, action) => {
      state.selectedSpecifiedArticlesResponsibility = action.payload;
    }),
  }),
});

export const {
  setSelectedSpecifiedArticlesResponsibilityInRedux,
} = roomSlice.actions;

// --- selectors ---------------------------------------------------------------

export const selectProjectNo = (state: IRootState) => state.design.projectNo;

export const selectSelectedSpecifiedArticlesResponsibility = (state: IRootState) =>
  state.room.selectedSpecifiedArticlesResponsibility;
